import { render } from "./ContactUsPage.vue?vue&type=template&id=479d04a4&scoped=true"
import script from "./ContactUsPage.vue?vue&type=script&lang=js"
export * from "./ContactUsPage.vue?vue&type=script&lang=js"

import "./ContactUsPage.vue?vue&type=style&index=0&id=479d04a4&lang=css"
import "./ContactUsPage.vue?vue&type=style&index=1&id=479d04a4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-479d04a4"]])

export default __exports__